export const NOTIFICATION_MESSAGE_KEY = 'spo-notification';
